import { RefObject, useEffect, useState, useMemo } from 'react';

const useIntersectionObserver = <T extends HTMLElement>(
  ref: RefObject<T>,
  options: IntersectionObserverInit,
) => {
  const [isIntersecting, setIsIntersecting] = useState(true);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      }, options),
    [options],
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [ref, options, observer]);

  return isIntersecting;
};

export default useIntersectionObserver;
